<script lang="ts" setup>
  import { useQuery } from '@pinia/colada';
  import { computed } from 'vue';
  import { feedbackListQuery } from '../../../shared/api/feedback.ts';
  import FeedbackView from './FeedbackView.vue';

  const { data } = useQuery(feedbackListQuery);

  const feedback = computed(() => data.value ?? []);
</script>

<template>
  <FeedbackView :feedback="feedback" />
</template>
